import UIFacade from "@baseUI/UIFacade";
import UISignals from "@baseUI/controllers/UISignals";
import UICreatorComponent from "@baseUI/utils/UICreatorComponent";
import UICreatorText from "@baseUI/utils/UICreatorText";
import UICreatorGraphics from "@baseUI/utils/UICreatorGraphics";
import UIBaseView from "@baseUI/views/UIBaseView";
import MenuPopupLayoutPortrait from "@baseUI/component/layout/MenuPopupLayoutPortrait";

export default class MobilePortraitView extends UIBaseView {

    constructor(uiModelView) {
        super(uiModelView)
    }

    setParametersSizePosition(){
        this.nameLayout = 'portraitLayout'

        this.param = {
            widthPanel: 1120,            //this.uiModelView.width + 100
            panelButtonsPosition: {x: 0, y: 2500},
            spinBtn: { name: 'mobileSpinPortrait_BUTTON', position: [0, 0]},
            maxBetBtn: { name: 'mobileBet_BUTTON', position: [250, 0]},
            autoplayBtn: { name: 'mobileAutoplayPortrait_BUTTON', position: [-250, 0]},
            autoplayCounterBtnPosition: { name: 'mobileAutoplayStop_BUTTON', position: [-250, 0]},
            isBottomWatch: false,
            infoBtn: {name: 'mobileInfo_BUTTON'},
            menuBtn: {name: 'mobileMenu_BUTTON'},
            soundBtn: {name: 'mobileSound_STATE'}
        }
    }

    init(){
        super.init()

        this.menuPopup = new MenuPopupLayoutPortrait()
        this.addChild(this.menuPopup)
        this.menuPopup.hide()
    }

    createPanelTop(widthPanel) {

        this.panelTop = UICreatorComponent.addContainer(this, {x: 0, y: 200})
        this.addGameNameWatchRTP(this.panelTop )
        // this.gameNameText = UICreatorText.addSimpleTextComponent('gameName_TEXT', 'systemTopText', panelTop, [-widthPanel / 2 + 150, 50])
        // this.watchText = UICreatorComponent.addWatches('watch', panelTop, [widthPanel / 2 - 100, 50])
        //
        // // ConfigDynamicTextStyleBase:  Watches : 'watch'
        // // ConfigDynamicTextStyleBase:  Watches : 'watch'
        // // PixiTextStylels      "watch": {}
        //
        //
        // //  if (UIFacade.model.maxwin && UIFacade.model._rtp) {
        // const rtpText = `MAX WIN: ${UIFacade.model.maxwin}   RTP: ${UIFacade.model._rtp}`
        // this.rtpText = UICreatorText.addElementTextSimple(rtpText, "systemTopText", panelTop, [0, 50])
        // // const rtpDynamic = this.localListComponent.get('rtpDynamic')
        // // Signals.setValue.dispatch('rtpDynamic', rtpText)
        // //  }
        // this.panelTop = panelTop
    }

    addSubstrateComponent(widthPanel, rectWidth){
        const xStart = -widthPanel / 2 - 20
        this.panelSubstrate.removeChildren()
        UICreatorGraphics.addRect(this.panelSubstrate, xStart, rectWidth + 3, widthPanel, 2 * rectWidth + 3, 0x323031, 0.7)
        UICreatorGraphics.addLine(this.panelSubstrate, xStart, 2 * rectWidth + 3, widthPanel, 2 * rectWidth + 3)
        UICreatorGraphics.addRect(this.panelSubstrate, xStart, 2 * rectWidth + 7, widthPanel, 3 * rectWidth, 0x323031, 0.9)
   }

    addFreespinsComponent(widthPanel, rectWidth){
        const xStart = -widthPanel / 2 - 20

        this.panelFS = UICreatorComponent.addContainer(this.panelBottom, {x: 0, y: 0})
        UICreatorGraphics.addRect(this.panelFS, xStart, 0, widthPanel, rectWidth, 0x323031, 0.7)
        UICreatorGraphics.addLine(this.panelFS, xStart, rectWidth, widthPanel, rectWidth)
        // todo: fs
        this.panelFS.interactive = false
        this.panelFS.visible = false
        this.fsText = UICreatorText.addElementDynamicTextName('mobileFS_DYNAMIC', this.panelFS, [50, 50])
        this.showFreeSpinsLeft(UIFacade.model.amountLeft)
        UISignals.setFreeSpinLeft.add((value) => {
            this.showFreeSpinsLeft(value)
        })
    }

    setPositionComponents(widthPanel, rectWidth){

        this.activeBets.position.set( -570, rectWidth + 5)
        this.winText.position.set(300, rectWidth + 20)
        this.winValue.position.set(this.winText.x, this.winText.y + 60)
        this.balanceText.position.set(-400, 280)
        this.balanceValue.position.set(this.balanceText.x + this.balanceText.width/2 + 20, this.balanceText.y)
        this.soundBtn.position.set(240, 280)
        this.infoBtn.position.set(340, 280)
        this.menuBtn.position.set(440, 280)
        this.fsText.position.set(50, 50)

        this.gameNameText.position.set( - widthPanel / 2 + 150, 50)
        this.watchText.position.set(widthPanel / 2 - 100, 50)
        this.rtpText.position.set(0, 50)
    }

    update() {
        this.x = 1390
        this.y = 200//400 + window.app.stage.y / this.uiModelView.scale
        //this.addSubstrateComponent( this.uiModelView.widthScreen, 110)
        this.panelBottom.y = 2250 + this.uiModelView.shiftY
        this.panelTop.y = -200 - this.uiModelView.shiftY
        this.panelButtons.y = 2200 + this.uiModelView.shiftY
        // this.menuPopup.y = 300 + this.uiModelView.shiftY/3
        this.menuPopup.updateSize(this.uiModelView)
    }

}
